<script>
    import {
        Button,
        Modal,
        ModalBody,
        ModalFooter,
        ModalHeader,
    } from "sveltestrap";

    import {
        nozzle_qty_1,
        nozzle_diam_1,
        nozzle_qty_2,
        nozzle_diam_2,
        nozzle_qty_3,
        nozzle_diam_3,
        tfa_1,
        tfa_2,
        tfa_3,
        tfa_total,
        tfaSigFigs,
        tfaDisplayUnit,
        nozzleSizeTFACardDisplayUnit,
        nozzleDiameterConversion,
        tfaConversion,
        range,
        tfaModalActiveSet,
        tfaModalQty,
        tfaModalSize,
        open,
        super2,
    } from "../../public/stores";
    //===============================TFA Chart==================================

    $: tfaTableMidPoint = 6;
    $: tfaTableMin = tfaTableMidPoint - 3;
    $: tfaTableMax = tfaTableMidPoint + 4;
    $: nozzle_qtys = range(tfaTableMin, tfaTableMax, 1);
    const nozzle_sizes = range(7, 25, 1);
    $: tfa_headers = ["S/Q"].concat(nozzle_qtys);

    function tfa_row_highlight_selector(nozzle_size) {
        if (nozzle_size % 2 === 0) {
            return "highlighted-row";
        } else {
            return "non-highlighted-row";
        }
    }

    function tfa_selected_combo_selector(nozzle_qty, nozzle_size) {
        if (nozzle_qty === $tfaModalQty && nozzle_size === $tfaModalSize) {
            return "tfa-selected-combo";
        } else {
            return "not-selected";
        }
    }

    function generate_id(nozzle_qty, nozzle_size) {
        return "tfa-" + String(nozzle_qty) + "-" + String(nozzle_size);
    }

    function select_new_combo(nozzle_qty, nozzle_size) {
        $tfaModalQty = nozzle_qty;
        $tfaModalSize = nozzle_size;
        let new_id = generate_id(nozzle_qty, nozzle_size);
        let new_selected_el = document.getElementById(new_id);

        let selectedElements = document.getElementsByClassName(
            "tfa-selected-combo"
        );
        let wholeTable = document.getElementsByClassName("tfa-col");
        Array.from(selectedElements).forEach(function (element) {
            element.classList.remove("tfa-selected-combo");
            element.classList.add("not-selected");
        });
        if (new_selected_el) {
            new_selected_el.classList.add("tfa-selected-combo");
        }
        running_tfa_total();
    }

    function add_nozzle_selection() {
        if ($tfaModalActiveSet === 1) {
            nozzle_qty_1.set($tfaModalQty);
            nozzle_diam_1.set($tfaModalSize);
        } else if ($tfaModalActiveSet === 2) {
            nozzle_qty_2.set($tfaModalQty);
            nozzle_diam_2.set($tfaModalSize);
        } else {
            nozzle_qty_3.set($tfaModalQty);
            nozzle_diam_3.set($tfaModalSize);
        }
        return $open = !$open;;
    }

    function running_tfa_total() {
        let selectedElements = document.getElementsByClassName(
            "tfa-selected-combo"
        );
        let selected_tfa = 0;
        let running_tfa_total = document.getElementById("running-tfa-total");
        Array.from(selectedElements).forEach(function (element) {
            selected_tfa = parseFloat(element.textContent);
        });

        let nzls_1 = "";
        let nzls_2 = "";
        let nzls_3 = "";
        let total_tfa_str =
            String($tfa_total.toFixed($tfaSigFigs)) +
            "(" +
            $tfaDisplayUnit +
            super2 +
            ")";
        let new_tfa = 0;

        if ($tfa_1 !== 0) {
            nzls_1 = String($tfa_1.toFixed($tfaSigFigs));
        }
        if ($tfa_2 !== 0) {
            nzls_2 = "+" + String($tfa_2.toFixed($tfaSigFigs));
        }
        if ($tfa_3 !== 0) {
            nzls_3 = "+" + String($tfa_3.toFixed($tfaSigFigs));
        }

        if (running_tfa_total === null) {
            if ($tfa_total > 0) {
                return nzls_1 + nzls_2 + nzls_3 + "=" + total_tfa_str;
            } else {
                return "Select Nozzle Qty/Size Combo";
            }
        }

        let selected_tfa_display = String(selected_tfa.toFixed($tfaSigFigs));
        if ($tfaModalActiveSet === 1) {
            new_tfa = selected_tfa + $tfa_2 + $tfa_3;
            return (running_tfa_total.textContent =
                selected_tfa_display +
                nzls_2 +
                nzls_3 +
                "=" +
                String(new_tfa.toFixed($tfaSigFigs)) +
                "(" +
                $tfaDisplayUnit +
                super2 +
                ")");
        } else if ($tfaModalActiveSet === 2) {
            new_tfa = $tfa_1 + selected_tfa + $tfa_3;
            return (running_tfa_total.textContent =
                nzls_1 +
                "+" +
                selected_tfa_display +
                nzls_3 +
                "=" +
                String(new_tfa.toFixed($tfaSigFigs)) +
                "(" +
                $tfaDisplayUnit +
                super2 +
                ")");
        } else {
            new_tfa = $tfa_1 + $tfa_2 + selected_tfa;
            return (running_tfa_total.textContent =
                nzls_1 +
                nzls_2 +
                "+" +
                selected_tfa_display +
                "=" +
                String(new_tfa.toFixed($tfaSigFigs)) +
                "(" +
                $tfaDisplayUnit +
                super2 +
                ")");
        }
    }
    function tfa_imperial(nozzleQty, nozzleDiamInInches) {
        const nozzleRadius = nozzleDiamInInches / 2;
        return nozzleQty * Math.PI * Math.pow(nozzleRadius, 2);
    }
    const toggle = () => ($open = !$open);
</script>

<style>
    #tfa-chart-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: stretch;
    }

    .col-sm {
        overflow-y: auto;
    }

    .break {
        flex-basis: 100%;
        height: 0;
    }

    .tfa-col {
        flex: 1;
        text-align: center;
        cursor: pointer;
    }

    .tfa-header {
        flex: 1;
        text-align: center;
        font-weight: bold;
        border-bottom: 1px solid darkgrey;
    }

    .tfa-header-col {
        flex: 1;
        text-align: center;
        font-weight: bold;
        border-right: 1px solid darkgrey;
    }

    .highlighted-row {
        background-color: rgba(0, 146, 159, 0.25);
    }

    .tfa-selected-combo {
        font-weight: bold;
        background-color: var(--inovative-green);
    }
    
    input[type="range"] {
        height: 31px;
        -webkit-appearance: none;
        margin: 10px 0;
        width: 100%;
    }
    input[type="range"]:focus {
        outline: none;
    }
    input[type="range"]::-webkit-slider-runnable-track {
        width: 100%;
        height: 10px;
        cursor: pointer;
        box-shadow: 0px 0px 0px #50555c;
        background: #9b9da0;
        border-radius: 10px;
        border: 0px solid #000000;
    }
    input[type="range"]::-webkit-slider-thumb {
        box-shadow: 0px 0px 0px #000000;
        border: 0px solid #000000;
        height: 25px;
        width: 40px;
        border-radius: 12px;
        background: #05929f;
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: -7.5px;
    }
    input[type="range"]:focus::-webkit-slider-runnable-track {
        background: #9b9da0;
    }
    input[type="range"]::-moz-range-track {
        width: 100%;
        height: 10px;
        cursor: pointer;
        box-shadow: 0px 0px 0px #50555c;
        background: #9b9da0;
        border-radius: 10px;
        border: 0px solid #000000;
    }
    input[type="range"]::-moz-range-thumb {
        box-shadow: 0px 0px 0px #000000;
        border: 0px solid #000000;
        height: 25px;
        width: 40px;
        border-radius: 12px;
        background: #05929f;
        cursor: pointer;
    }
    input[type="range"]::-ms-track {
        width: 100%;
        height: 10px;
        cursor: pointer;
        background: transparent;
        border-color: transparent;
        color: transparent;
    }
    input[type="range"]::-ms-fill-lower {
        background: #9b9da0;
        border: 0px solid #000000;
        border-radius: 20px;
        box-shadow: 0px 0px 0px #50555c;
    }
    input[type="range"]::-ms-fill-upper {
        background: #9b9da0;
        border: 0px solid #000000;
        border-radius: 20px;
        box-shadow: 0px 0px 0px #50555c;
    }
    input[type="range"]::-ms-thumb {
        margin-top: 1px;
        box-shadow: 0px 0px 0px #000000;
        border: 0px solid #000000;
        height: 25px;
        width: 40px;
        border-radius: 12px;
        background: #05929f;
        cursor: pointer;
    }
    input[type="range"]:focus::-ms-fill-lower {
        background: #9b9da0;
    }
    input[type="range"]:focus::-ms-fill-upper {
        background: #9b9da0;
    }
</style>

<Modal isOpen={$open} {toggle}>
    <ModalHeader {toggle}>
        <div style="font-size: 1rem;">
            Select Nozzles From TFA Chart ({$tfaDisplayUnit})<sup>2</sup>
        </div>
        <div style="font-size: 1rem;" id="running-tfa-total">
            {running_tfa_total()}
        </div>
    </ModalHeader>
    <ModalBody style="font-size: 0.75rem;">
        <label
            style="font-size: 1rem; display: flex; align-items: center; justify-content: center;">
            Nozzle Qty Range:
            <input
                id="table-mid-point"
                style="width: 50%; margin-left: 5px;"
                type="range"
                bind:value={tfaTableMidPoint}
                on:input={() => select_new_combo($tfaModalQty, $tfaModalSize)}
                min="4"
                max="10" />
        </label>
        <div id="tfa-chart-container">
            {#each tfa_headers as header}
                <div class="tfa-header">{header}</div>
            {/each}
            <div class="break" />
            {#each nozzle_sizes as size}
                <div class="tfa-header-col {tfa_row_highlight_selector(size)}">
                    {size}{$nozzleSizeTFACardDisplayUnit}
                </div>
                {#each nozzle_qtys as qty}
                    <div
                        class="tfa-col {tfa_row_highlight_selector(size)} {tfa_selected_combo_selector(qty, size)}"
                        id={generate_id(qty, size)}
                        on:click={() => select_new_combo(qty, size)}>
                        {(tfa_imperial({ qty }['qty'], { size }['size'] / $nozzleDiameterConversion) * $tfaConversion).toFixed($tfaSigFigs)}
                    </div>
                {/each}
                <div class="break" />
            {/each}
        </div>
    </ModalBody>
    <ModalFooter>
        <Button color="secondary" on:click={() => add_nozzle_selection()}>
            Add Selected Nozzles
        </Button>
        <Button color="secondary" on:click={toggle}>Cancel</Button>
    </ModalFooter>
</Modal>
